const en_common = {
  // Navigation
  "nav.home": "Home",
  "nav.about": "About Us",
  "nav.services": "Services",
  "nav.doctors": "Consultants",
  "nav.packages": "Care Levels",
  "nav.dna_simulator": "DNA Simulator",
  "nav.offers": "Offers",
  "nav.blog": "Blog",
  "nav.faq": "FAQ",
  "nav.contact": "Contact Us",
  "nav.book": "Book Appointment",
  "nav.search": "Search...",
  "nav.lang_switch": "عربي",

  // Common buttons
  "btn.book_now": "Book Now",
  "btn.learn_more": "Learn More",
  "btn.view_all": "View All",
  "btn.back": "Back",
  "btn.next": "Next",
  "btn.submit": "Submit",
  "btn.close": "Close",
  "btn.details": "Details",
  "btn.contact_us": "Contact Us",
  "btn.show_results": "Show Results",
  "btn.retake": "Retake Assessment",

  // Common labels
  "label.sar": "SAR",
  "label.minutes": "min",
  "label.years_exp": "years exp.",
  "label.free": "Free",
  "label.save": "Save",
  "label.most_popular": "Most Popular",
  "label.exclusive": "Exclusive",
  "label.featured": "Featured",
  "label.new": "New",
  "label.available": "Available",
  "label.loading": "Loading...",
  "label.no_results": "No results found",

  // Footer
  "footer.tagline": "Advanced Precision Medicine & Specialty Care Platform",
  "footer.quick_links": "Quick Links",
  "footer.services": "Services",
  "footer.contact_info": "Contact Information",
  "footer.rights": "All Rights Reserved",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms & Conditions",
  "footer.newsletter": "Subscribe to Newsletter",
  "footer.newsletter_desc": "Latest articles and medical offers",
  "footer.newsletter_placeholder": "Your email address",
  "footer.newsletter_btn": "Subscribe",

  // WhatsApp
  "whatsapp.tooltip": "Chat on WhatsApp",

  // Search
  "search.placeholder": "Search for a doctor, service, package...",
  "search.no_results": "No results for",
  "search.advanced": "Advanced Search",
  "search.doctors": "Doctors",
  "search.services": "Services",
  "search.packages": "Packages",
  "search.view_all": "View all results for",

  "days.sun": "Sun",
  "days.mon": "Mon",
  "days.tue": "Tue",
  "days.wed": "Wed",
  "days.thu": "Thu",
  "days.fri": "Fri",
  "days.sat": "Sat",
  "months.jan": "Jan",
  "months.feb": "Feb",
  "months.mar": "Mar",
  "months.apr": "Apr",
  "months.may": "May",
  "months.jun": "Jun",
  "months.jul": "Jul",
  "months.aug": "Aug",
  "months.sep": "Sep",
  "months.oct": "Oct",
  "months.nov": "Nov",
  "months.dec": "Dec",
};

export default en_common;
